export default "__VITE_PUBLIC_ASSET__02d52c69__"